var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBug } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BCard } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, onMounted, ref } from "vue";
import { GalaxyApi } from "@/api";
import { fetchDatasetDetails } from "@/api/datasets";
import {} from "@/api/jobs";
import { useMarkdown } from "@/composables/markdown";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import { errorMessageAsString } from "@/utils/simple-error";
import DatasetErrorDetails from "@/components/DatasetInformation/DatasetErrorDetails.vue";
import FormElement from "@/components/Form/FormElement.vue";
import GalaxyWizard from "@/components/GalaxyWizard.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetError',
    props: {
        datasetId: null
    },
    setup(__props) {
        const props = __props;
        library.add(faBug);
        const userStore = useUserStore();
        const { currentUser } = storeToRefs(userStore);
        const { renderMarkdown } = useMarkdown({ openLinksInNewPage: true });
        const message = ref("");
        const jobLoading = ref(true);
        const errorMessage = ref("");
        const datasetLoading = ref(false);
        const jobDetails = ref();
        const jobProblems = ref();
        const resultMessages = ref([]);
        const dataset = ref();
        const showForm = computed(() => {
            const noResult = !resultMessages.value.length;
            const hasError = resultMessages.value.some((msg) => msg[1] === "danger");
            return noResult || hasError;
        });
        function getDatasetDetails() {
            return __awaiter(this, void 0, void 0, function* () {
                datasetLoading.value = true;
                try {
                    const data = yield fetchDatasetDetails({ id: props.datasetId });
                    dataset.value = data;
                }
                catch (e) {
                    errorMessage.value = errorMessageAsString(e) || "Unable to fetch available dataset details.";
                }
                finally {
                    datasetLoading.value = false;
                }
            });
        }
        function getJobDetails(jobId) {
            return __awaiter(this, void 0, void 0, function* () {
                jobLoading.value = true;
                try {
                    const { data, error } = yield GalaxyApi().GET("/api/jobs/{job_id}", {
                        params: {
                            path: { job_id: jobId },
                            query: { full: true },
                        },
                    });
                    if (error) {
                        errorMessage.value = errorMessageAsString(error) || "Unable to fetch job details.";
                        return;
                    }
                    jobDetails.value = data;
                }
                finally {
                    jobLoading.value = false;
                }
            });
        }
        function getJobProblems(jobId) {
            return __awaiter(this, void 0, void 0, function* () {
                const { data, error } = yield GalaxyApi().GET("/api/jobs/{job_id}/common_problems", {
                    params: {
                        path: { job_id: jobId },
                    },
                });
                if (error) {
                    errorMessage.value = errorMessageAsString(error) || "Unable to fetch job problems.";
                    return;
                }
                jobProblems.value = data;
            });
        }
        function submit(dataset, userEmailJob) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!dataset) {
                    errorMessage.value = "No dataset found.";
                    return;
                }
                const { data, error } = yield GalaxyApi().POST("/api/jobs/{job_id}/error", {
                    params: {
                        path: { job_id: dataset.creating_job },
                    },
                    body: {
                        dataset_id: dataset.id,
                        message: message.value,
                        email: userEmailJob,
                    },
                });
                if (error) {
                    errorMessage.value = errorMessageAsString(error);
                    return;
                }
                resultMessages.value = data.messages;
            });
        }
        function onMissingJobId() {
            errorMessage.value = "No job ID found for this dataset.";
        }
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield getDatasetDetails();
            const creatingJobId = (_a = dataset.value) === null || _a === void 0 ? void 0 : _a.creating_job;
            if (!creatingJobId) {
                onMissingJobId();
                return;
            }
            yield getJobDetails(creatingJobId);
            yield getJobProblems(creatingJobId);
        }));
        return { __sfc: true, props, userStore, currentUser, renderMarkdown, message, jobLoading, errorMessage, datasetLoading, jobDetails, jobProblems, resultMessages, dataset, showForm, getDatasetDetails, getJobDetails, getJobProblems, submit, onMissingJobId, faBug, FontAwesomeIcon, BAlert, BButton, BCard, localize, DatasetErrorDetails, FormElement, GalaxyWizard };
    }
});
